"use client";

import { FC, ReactNode } from "react";

import { Button } from "@/components/ui/button";
import { addRationToCart } from "@/lib/cart";
import { useBasketStore } from "@/store/useStore";
import { Icon } from "@/components/ui/icon";
import { ArrowRight02Icon } from "@hugeicons/core-free-icons";

type Props = {
  calories: string;
  pricePerDay: number;
  /** Сколько блюд в дне — корзина показывает это в позиции. */
  dishesCount: number;
  children: ReactNode;
  className?: string;
};

/**
 * Кладёт рацион в корзину прямо со страницы и открывает её.
 *
 * Дни не выбираем — их человек отмечает в самой корзине, как и при заказе с
 * витрины. Раньше кнопка просто уводила на главную с выбранным рационом, и
 * добавлять его приходилось заново.
 */
export const OrderRationButton: FC<Props> = ({
  calories,
  pricePerDay,
  dishesCount,
  children,
  className,
}) => {
  const setIsBasketOpen = useBasketStore((state) => state.setIsBasketOpen);

  const order = () => {
    addRationToCart({ calories, pricePerDay, dishesCount });
    setIsBasketOpen(true);
  };

  return (
    <Button size="lg" onClick={order} className={className}>
      <p className="font-bold text-colorPrimary">{children}</p>
      <Icon icon={ArrowRight02Icon}
        strokeWidth={0.6}
        className="text-colorPrimary transition-transform group-hover:translate-x-1"
      />
    </Button>
  );
};
